import React from 'react';

const TOTAL_PASOS = 4;

export const ProgressBar = ({ paso }) => {
    return (
        <div className="progress-bar">
            {Array.from({ length: TOTAL_PASOS }, (_, i) => (
                <React.Fragment key={i}>
                    <div className={`progress-step ${i + 1 < paso ? 'done' : i + 1 === paso ? 'active' : 'pending'}`}>
                        {i + 1 < paso ? '✓' : i + 1}
                    </div>
                    {i < TOTAL_PASOS - 1 && (
                        <div className={`progress-line ${i + 1 < paso ? 'done' : ''}`} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};
